/** Source-authored secondary-page UI. Managed legal/helpdesk content remains separate. */
export const PUBLIC_PAGE_FA: Readonly<Record<string,string>> = {
  "World map showing aggregated community risk": "نقشهٔ جهان با خطر تجمیع‌شدهٔ جامعه",
  "Evidence with integrity": "شواهد با حفظ صحت",
  "© 2026 Kavoosh. Review prototype.": "© ۲۰۲۶ کاووش. نمونهٔ در حال بازبینی.",
  "Iran": "ایران",
  "KAVOOSH PUBLIC INTELLIGENCE": "اطلاعات عمومی تهدید در کاووش",
  "Community threat landscape": "چشم‌انداز تهدیدهای جامعه",
  "Aggregated, privacy-preserving signals from support incidents, forensic findings and digital wellness assessments.": "نشانه‌های تجمیع‌شده با حفظ حریم خصوصی، برگرفته از رخدادهای پشتیبانی، یافته‌های بررسی فنی و ارزیابی‌های سلامت امنیت دیجیتال.",
  "Illustrative demonstration data · Not a live operational feed": "داده‌های نمایشی · این صفحه جریان زندهٔ عملیات نیست",
  "Privacy threshold active": "حداقل اندازهٔ گروه برای حفظ حریم خصوصی اعمال می‌شود",
  "Results appear only when at least 10 observations can be safely aggregated.": "نتایج تنها زمانی نمایش داده می‌شوند که دست‌کم ۱۰ مشاهده با رعایت حریم خصوصی قابل تجمیع باشد.",
  "Explore the data": "کاوش داده‌ها",
  "All filters update the complete dashboard": "فیلترها بر همهٔ بخش‌های داشبورد اعمال می‌شوند",
  "Reset filters": "بازنشانی فیلترها",
  "Time period": "بازهٔ زمانی",
  "Last 12 months": "۱۲ ماه گذشته",
  "Last 90 days": "۹۰ روز گذشته",
  "Last 30 days": "۳۰ روز گذشته",
  "Custom range": "بازهٔ دلخواه",
  "From": "از",
  "To": "تا",
  "Threat type": "نوع تهدید",
  "All threats": "همهٔ تهدیدها",
  "Phishing & social engineering": "فیشینگ و مهندسی اجتماعی",
  "Account compromise": "دسترسی غیرمجاز به حساب",
  "Malware": "بدافزار",
  "Spyware / targeted surveillance": "جاسوس‌افزار / نظارت هدفمند",
  "Impersonation": "جعل هویت",
  "Doxxing & online harassment": "افشای اطلاعات شخصی و آزار آنلاین",
  "Credential theft": "سرقت اطلاعات ورود",
  "Device confiscation": "ضبط دستگاه",
  "Arrest / detention-related device risk": "خطر دستگاه در ارتباط با بازداشت",
  "Malicious-code delivery": "انتقال کد مخرب",
  "DDoS / service disruption": "حملهٔ منع سرویس / اختلال خدمت",
  "Platform suspension / access failure": "تعلیق حساب در پلتفرم / اختلال دسترسی",
  "SIM / OTP interference": "دستکاری سیم‌کارت / رمز یک‌بارمصرف",
  "Network shutdown / censorship": "قطع شبکه / سانسور",
  "Disinformation / influence operation": "اطلاعات نادرست / عملیات نفوذ",
  "Transnational digital repression": "سرکوب دیجیتال فرامرزی",
  "Proactive security consultation": "مشاورهٔ پیشگیرانهٔ امنیتی",
  "Affected group": "گروه تحت تأثیر",
  "All groups": "همهٔ گروه‌ها",
  "Journalists": "روزنامه‌نگاران",
  "Political activists": "فعالان سیاسی",
  "Women’s-rights defenders": "مدافعان حقوق زنان",
  "Human-rights defenders": "مدافعان حقوق بشر",
  "Human-rights lawyers": "وکلای حقوق بشر",
  "Ethnic-minority rights defenders": "مدافعان حقوق اقلیت‌های قومی",
  "Ethnic-minority defenders": "مدافعان اقلیت‌های قومی",
  "Digital-rights defenders": "مدافعان حقوق دیجیتال",
  "Diaspora activists": "فعالان خارج از کشور",
  "Researchers & academics": "پژوهشگران و دانشگاهیان",
  "Artists & cultural workers": "هنرمندان و فعالان فرهنگی",
  "Podcasters & independent creators": "پادکست‌سازان و تولیدکنندگان مستقل محتوا",
  "General public": "عموم مردم",
  "Media & news organizations": "سازمان‌های رسانه‌ای و خبری",
  "Human-rights organizations": "سازمان‌های حقوق بشری",
  "Civil-society organizations": "سازمان‌های جامعهٔ مدنی",
  "Ethnic-minority organizations": "سازمان‌های اقلیت‌های قومی",
  "Digital-rights organizations": "سازمان‌های حقوق دیجیتال",
  "Political / opposition groups": "گروه‌های سیاسی / مخالف",
  "Target context": "زمینهٔ هدف",
  "Individuals & organizations": "افراد و سازمان‌ها",
  "Individuals": "افراد",
  "Organizations": "سازمان‌ها",
  "Geographic context": "زمینهٔ جغرافیایی",
  "All locations": "همهٔ مکان‌ها",
  "Inside Iran": "داخل ایران",
  "Iranian diaspora": "ایرانیان خارج از کشور",
  "Regional civil society": "جامعهٔ مدنی منطقه",
  "Global": "جهانی",
  "Minimum group size: 10": "حداقل اندازهٔ گروه: ۱۰",
  "Community risk index": "شاخص خطر جامعه",
  "vs previous period": "در مقایسه با دورهٔ قبل",
  "out of 100": "از ۱۰۰",
  "Likely next-30-day threat": "تهدید احتمالی در ۳۰ روز آینده",
  "72% likelihood ·": "احتمال ۷۲٪ ·",
  "High confidence": "اطمینان زیاد",
  "Medium confidence": "اطمینان متوسط",
  "Low confidence": "اطمینان کم",
  "Prediction—not an observed incident": "پیش‌بینی است؛ رخداد مشاهده‌شده نیست",
  "Most affected community": "جامعه با بیشترین تأثیرپذیری",
  "Exposure is 12% above the community baseline": "میزان مواجهه ۱۲٪ بالاتر از سطح مبنای جامعه است",
  "Illustrative reports in selection": "گزارش‌های نمایشی در انتخاب فعلی",
  "Aggregated": "تجمیع‌شده",
  "De-identified": "بدون مشخصات هویتی",
  "Reviewed": "بازبینی‌شده",
  "Demonstration snapshot": "نمای ثابت داده‌های نمایشی",
  "Who is targeted": "چه کسانی هدف قرار می‌گیرند",
  "Affected communities": "جوامع تحت تأثیر",
  "18 profiles": "۱۸ گروه",
  "People": "افراد",
  "Fastest rising exposure": "بیشترین افزایش مواجهه",
  "Women’s-rights defenders show the sharpest increase this period.": "مدافعان حقوق زنان در این دوره بیشترین افزایش را نشان می‌دهند.",
  "Media outlets and podcasting groups show the fastest recent growth.": "رسانه‌ها و گروه‌های پادکست‌ساز بیشترین افزایش اخیر را نشان می‌دهند.",
  "Geographic risk": "خطر جغرافیایی",
  "Province-level view": "نمای استانی",
  "Global risk heatmap": "نقشهٔ شدت خطر در جهان",
  "Hover for a quick summary. Select a country to filter all panels. Iran opens province detail.": "برای خلاصه، نشانگر را روی نقشه ببرید. با انتخاب کشور همهٔ بخش‌ها فیلتر می‌شوند. انتخاب ایران نمای استان‌ها را باز می‌کند.",
  "← Back to world": "بازگشت به نقشهٔ جهان →",
  "Zoom in": "بزرگ‌نمایی",
  "Zoom out": "کوچک‌نمایی",
  "Click to filter the dashboard": "برای فیلترکردن داشبورد انتخاب کنید",
  "Insufficient data for a safe public estimate": "دادهٔ کافی برای برآورد عمومی با حفظ حریم خصوصی وجود ندارد",
  "Privacy threshold or coverage requirement not met": "حداقل اندازهٔ گروه یا پوشش لازم فراهم نیست",
  "Risk index": "شاخص خطر",
  "Lower": "کمتر",
  "Critical": "بحرانی",
  "No public estimate": "بدون برآورد عمومی",
  "Current selection": "انتخاب فعلی",
  "Global community": "جامعهٔ جهانی",
  "Risk": "خطر",
  "Clear": "پاک کردن",
  "What is happening": "چه اتفاقی در جریان است",
  "Threat composition": "ترکیب تهدیدها",
  "17 categories": "۱۷ دسته",
  "risk index": "شاخص خطر",
  "Device / detention-related risk": "خطر مرتبط با دستگاه / بازداشت",
  "Malware & spyware": "بدافزار و جاسوس‌افزار",
  "Doxxing & harassment": "افشای اطلاعات شخصی و آزار",
  "View full threat taxonomy": "مشاهدهٔ همهٔ دسته‌های تهدید",
  "Show leading categories only": "نمایش فقط دسته‌های اصلی",
  "30-DAY FORECAST": "پیش‌بینی ۳۰ روزه",
  "Phishing likely to remain dominant": "احتمالاً فیشینگ همچنان تهدید اصلی خواهد بود",
  "Confidence 72% · driven by helpdesk trend and recent forensic signals.": "اطمینان ۷۲٪ · بر پایهٔ روند پشتیبانی و نشانه‌های اخیر بررسی فنی.",
  "CHANGE OVER TIME": "تغییرات در گذر زمان",
  "Observed incidents, unusual volume and predicted exposure": "رخدادهای مشاهده‌شده، حجم غیرعادی و مواجههٔ پیش‌بینی‌شده",
  "Observed": "مشاهده‌شده",
  "Predicted": "پیش‌بینی‌شده",
  "Context event": "رویداد زمینه‌ای",
  "Jan volume anomaly": "حجم غیرعادی در ژانویه",
  "Sep": "سپتامبر",
  "Nov": "نوامبر",
  "Jan": "ژانویه",
  "Mar": "مارس",
  "May": "مه",
  "Jul": "ژوئیه",
  "REVIEWED CONTEXT EVENT": "رویداد زمینه‌ای بازبینی‌شده",
  "Nationwide protest period coincided with an exceptional rise in digital-safety support demand.": "دورهٔ اعتراضات سراسری با افزایش چشمگیر تقاضای پشتیبانی امنیت دیجیتال هم‌زمان بوده است.",
  "This public annotation explains the correlation without exposing tickets or treating an administrator’s note as proof of causation.": "این توضیح عمومی، هم‌زمانی را شرح می‌دهد؛ درخواست‌های خصوصی را افشا نمی‌کند و یادداشت مدیر را اثبات رابطهٔ علت و معلولی نمی‌داند.",
  "Detected volume": "حجم شناسایی‌شده",
  "148% above expected range": "۱۴۸٪ بالاتر از محدودهٔ مورد انتظار",
  "Independent support": "تأیید مستقل",
  "3 signal streams": "۳ جریان نشانه",
  "Risk-model effect": "اثر بر مدل خطر",
  "Bounded uplift · 14-day decay": "افزایش محدود · کاهش اثر طی ۱۴ روز",
  "Governance": "نظارت و تأیید",
  "Senior Analyst approved": "تأییدشده توسط تحلیلگر ارشد",
  "Why this matters": "چرا مهم است",
  "Volume alone does not increase risk. Kavoosh first checks seasonality, delayed imports, Helpdesk capacity, outreach changes, geography and threat mix. Only a persistent, corroborated and approved surge can contribute a capped signal to the risk model.": "حجم به‌تنهایی خطر را افزایش نمی‌دهد. کاووش ابتدا الگوهای فصلی، تأخیر ورود داده، ظرفیت پشتیبانی، تغییرات اطلاع‌رسانی، جغرافیا و ترکیب تهدید را بررسی می‌کند. تنها افزایش پایدار، تأییدشده و بازبینی‌شده می‌تواند اثری محدود بر مدل خطر بگذارد.",
  "Sources and method": "منابع و روش",
  "This view combines de-identified Helpdesk records, Kavoosh forensic findings, digital wellness assessments and vetted threat-intelligence signals. Sources are not filters: they are weighted, quality-checked inputs. Observed patterns and predictions remain visually distinct and never identify an individual.": "این نما، داده‌های پشتیبانی بدون مشخصات هویتی، یافته‌های بررسی فنی کاووش، ارزیابی‌های سلامت امنیت دیجیتال و اطلاعات تهدید بررسی‌شده را ترکیب می‌کند. منابع، ورودی‌های وزن‌دهی‌شده با کنترل کیفیت هستند. الگوهای مشاهده‌شده و پیش‌بینی‌ها جدا نمایش داده می‌شوند و هویت هیچ فردی را آشکار نمی‌کنند.",
  "Read methodology →": "مطالعهٔ روش‌شناسی ←",
  "Province view": "نمای استان‌ها",
  "Selected province": "استان انتخاب‌شده",
  "Select any province": "یک استان انتخاب کنید",
  "All 31 provinces are selectable; color reflects the current aggregate risk band.": "هر ۳۱ استان قابل انتخاب است؛ رنگ، سطح خطر تجمیع‌شدهٔ فعلی را نشان می‌دهد.",
  "KAVOOSH APPLICATIONS": "نرم‌افزارهای کاووش",
  "Secure tools for every supported platform": "ابزارهای امن برای هر پلتفرم پشتیبانی‌شده",
  "Access the web workspace or install a platform-specific companion. Every release will be signed, versioned and traceable to its published checksum.": "از فضای کاری وب استفاده کنید یا برنامهٔ همراه مناسب دستگاه خود را نصب کنید. هر انتشار، امضا و نسخه دارد و با جمع بررسی منتشرشده قابل تطبیق خواهد بود.",
  "Release channel": "کانال انتشار",
  "Stable": "پایدار",
  "Beta": "آزمایشی",
  "Latest-version destinations are controlled by Platform Admin": "مقصد دریافت آخرین نسخه را مدیر پلتفرم تعیین می‌کند",
  "For every OS and channel, Admin manages the public detail page, version, store or direct-download destination, checksum, signature, requirements, release notes, publication state and emergency withdrawal. No desktop forensic tool links directly to a package before its usage conditions are shown.": "مدیر برای هر سیستم‌عامل و کانال، صفحهٔ جزئیات، نسخه، مقصد دریافت، جمع بررسی، امضا، پیش‌نیازها، توضیحات انتشار، وضعیت انتشار و لغو اضطراری را مدیریت می‌کند. پیش از دریافت ابزار بررسی فنی، شرایط استفاده نمایش داده می‌شود.",
  "Kavoosh Web Platform": "پلتفرم وب کاووش",
  "Modern web browsers": "مرورگرهای وب امروزی",
  "Development preview": "پیش‌نمایش توسعه",
  "Secure cases, organizations, devices, risk intelligence and evidence-led analysis in one role-aware workspace.": "پرونده‌ها، سازمان‌ها، دستگاه‌ها، اطلاعات خطر و تحلیل مبتنی بر شواهد در فضای کاری متناسب با نقش شما.",
  "Understand the web platform": "آشنایی با پلتفرم وب",
  "Checkpoint 12 foundation · FastAPI + React architecture": "زیرساخت مرحلهٔ ۱۲ · معماری FastAPI و React",
  "Android Companion": "برنامهٔ همراه Android",
  "Android 10 and later · planned": "Android 10 و بالاتر · برنامه‌ریزی‌شده",
  "In development": "در حال توسعه",
  "Enroll devices, review collection requests, choose data categories and see installation status.": "دستگاه‌ها را ثبت کنید، درخواست‌های جمع‌آوری را بررسی کنید، دسته‌های داده را انتخاب کنید و وضعیت نصب را ببینید.",
  "Understand the mobile app": "آشنایی با برنامهٔ همراه",
  "Provider and local pipeline foundation built; runtime/UI activation remains gated": "زیرساخت ارائه‌دهنده و پردازش محلی ساخته شده؛ فعال‌سازی برنامه و رابط به تأییدهای بعدی نیاز دارد",
  "Windows Forensic Collector": "کالکتور بررسی فنی Windows",
  "Consent-led forensic collection with protected enrollment, signed packages and bounded collection levels.": "جمع‌آوری شواهد با رضایت شما، ثبت امن دستگاه، بسته‌های امضاشده و دامنهٔ مشخص جمع‌آوری.",
  "Understand the collector": "آشنایی با کالکتور",
  "Security contracts advanced; no public release accepted": "الزامات امنیتی پیش رفته است؛ هنوز انتشار عمومی تأیید نشده",
  "Planned": "برنامه‌ریزی‌شده",
  "macOS Forensic Collector": "کالکتور بررسی فنی macOS",
  "macOS · target versions to confirm": "macOS · نسخه‌های هدف هنوز تأیید نشده",
  "Native collection workflows designed to follow the same shared protocol and chain-of-custody contract.": "فرایند بومی جمع‌آوری با پروتکل مشترک و الزامات ثبت زنجیرهٔ نگهداری شواهد طراحی می‌شود.",
  "Repository scaffold required before collector implementation": "پیش از پیاده‌سازی کالکتور، ساختار پروژه باید آماده شود",
  "Linux Forensic Collector": "کالکتور بررسی فنی Linux",
  "Ubuntu, Fedora and other distributions": "Ubuntu، Fedora و دیگر توزیع‌ها",
  "Distribution-aware packaging and bounded local evidence collection for supported Linux environments.": "بسته‌بندی متناسب با توزیع و جمع‌آوری محلی با دامنهٔ مشخص برای محیط‌های پشتیبانی‌شدهٔ Linux.",
  "Distribution matrix and packaging pipelines not yet accepted": "فهرست توزیع‌ها و فرایند بسته‌بندی هنوز تأیید نشده",
  "Current state": "وضعیت فعلی",
  "iOS Companion": "برنامهٔ همراه iOS",
  "iOS/iPadOS · target versions to confirm": "iOS/iPadOS · نسخه‌های هدف هنوز تأیید نشده",
  "Secure requests, consent, case status and guided device handoff for supported collection workflows.": "درخواست امن، ثبت رضایت، مشاهدهٔ وضعیت پرونده و راهنمای تحویل دستگاه در فرایندهای پشتیبانی‌شده.",
  "Mobile project scaffold and store pipeline still required": "ساختار پروژهٔ موبایل و فرایند انتشار در فروشگاه هنوز لازم است",
  "PLANNED SECURITY AGENTS": "عامل‌های امنیتی برنامه‌ریزی‌شده",
  "Ongoing device protection is not forensic collection.": "محافظت مستمر از دستگاه با جمع‌آوری شواهد متفاوت است.",
  "Each operating system needs a native, least-privilege Agent for protected enrollment, health, posture, signed policy and user-visible warnings. These agents are planned product infrastructure and are not yet available for download.": "هر سیستم‌عامل به عاملی بومی با حداقل دسترسی برای ثبت امن، سلامت دستگاه، وضعیت امنیتی، سیاست امضاشده و هشدار قابل‌مشاهده نیاز دارد. این عامل‌ها در برنامهٔ توسعه هستند و هنوز قابل دریافت نیستند.",
  "Architecture planned": "معماری برنامه‌ریزی‌شده",
  "Windows Security Agent": "عامل امنیتی Windows",
  "macOS Security Agent": "عامل امنیتی macOS",
  "Linux Security Agent": "عامل امنیتی Linux",
  "Android Security Agent": "عامل امنیتی Android",
  "iOS Security Agent": "عامل امنیتی iOS",
  "Native service, updater and device-health adapters required": "سرویس بومی، به‌روزرسان و اجزای بررسی سلامت دستگاه مورد نیاز است",
  "System Extension and notarized update design required": "طراحی افزونهٔ سیستم و به‌روزرسانی تأییدشده مورد نیاز است",
  "Supported Ubuntu and Fedora releases": "نسخه‌های پشتیبانی‌شدهٔ Ubuntu و Fedora",
  "Distribution packages and service manager contracts required": "بسته‌های توزیع و الزامات مدیریت سرویس مورد نیاز است",
  "Companion-based posture and background-work constraints to define": "وضعیت امنیتی مبتنی بر برنامهٔ همراه و محدودیت‌های فعالیت پس‌زمینه باید مشخص شود",
  "Platform-limited posture model and managed-device boundaries to define": "مدل وضعیت امنیتی با محدودیت پلتفرم و حدود دستگاه مدیریت‌شده باید مشخص شود",
  "View responsibilities and boundaries →": "مشاهدهٔ وظایف و حدود دسترسی ←",
  "TRUSTED DISTRIBUTION": "توزیع قابل اعتماد",
  "What every download should show": "اطلاعاتی که هر دریافت باید داشته باشد",
  "Direct downloads and store listings must provide the same evidence of authenticity.": "دریافت مستقیم و فهرست فروشگاه باید مدارک یکسانی برای بررسی اصالت ارائه دهند.",
  "Release signature": "امضای انتشار",
  "Platform signing identity and verification guide": "هویت امضاکنندهٔ پلتفرم و راهنمای بررسی",
  "SHA-256 checksum": "جمع بررسی SHA-256",
  "Published beside each direct download": "منتشرشده کنار هر دریافت مستقیم",
  "Version & release notes": "نسخه و توضیحات انتشار",
  "Collector and consent version recorded per case": "نسخهٔ کالکتور و رضایت ثبت‌شده برای هر پرونده",
  "Supported systems": "سیستم‌های پشتیبانی‌شده",
  "Exact OS, architecture and dependency matrix": "فهرست دقیق سیستم‌عامل، معماری و وابستگی‌ها",
  "PLANNED DISTRIBUTION": "روش‌های توزیع برنامه‌ریزی‌شده",
  "Direct verified download": "دریافت مستقیم با بررسی اصالت",
  "MANAGED ORGANIZATIONS": "سازمان‌های مدیریت‌شده",
  "Private deployment": "استقرار خصوصی",
  "ABOUT KAVOOSH": "دربارهٔ کاووش",
  "Built for people facing real digital risk": "برای افرادی که با خطر واقعی دیجیتال روبه‌رو هستند",
  "Kavoosh is a privacy-first platform for secure support, forensic evidence, organizational resilience and explainable threat intelligence.": "کاووش پلتفرمی با اولویت حریم خصوصی برای پشتیبانی امن، شواهد بررسی فنی، تاب‌آوری سازمانی و اطلاعات تهدید قابل توضیح است.",
  "Privacy before visibility": "حریم خصوصی پیش از نمایش اطلاعات",
  "Personal data is never made public. Aggregated views use minimum-group thresholds and strict role boundaries.": "دادهٔ شخصی هرگز عمومی نمی‌شود. نماهای تجمیع‌شده حداقل اندازهٔ گروه و حدود دقیق نقش‌ها را رعایت می‌کنند.",
  "Read principle": "مطالعهٔ اصل",
  "Evidence before assumptions": "شواهد پیش از فرضیات",
  "Every analytic signal keeps its source, freshness, confidence and model version.": "هر نشانهٔ تحلیلی، منبع، زمان به‌روزرسانی، میزان اطمینان و نسخهٔ مدل خود را حفظ می‌کند.",
  "People before automation": "انسان پیش از خودکارسازی",
  "Predictions guide human review; they do not make punitive or irreversible decisions.": "پیش‌بینی‌ها راهنمای بازبینی انسانی هستند؛ تصمیم تنبیهی یا برگشت‌ناپذیر نمی‌گیرند.",
  "One system, separate contexts": "یک سامانه با زمینه‌های جدا",
  "A person may belong to several organizations while keeping personal devices and data private.": "هر فرد می‌تواند عضو چند سازمان باشد و هم‌زمان دستگاه‌ها و داده‌های شخصی خود را خصوصی نگه دارد.",
  "READY FOR THE NEXT STEP?": "برای گام بعدی آماده‌اید؟",
  "See what community-level insight looks like": "تحلیل در سطح جامعه را ببینید",
  "Explore analytics": "مشاهدهٔ تحلیل‌ها",
  "PRACTICAL SAFETY GUIDES": "راهنماهای کاربردی امنیت",
  "Clear guidance for safer digital work": "راهنمای روشن برای فعالیت دیجیتال امن‌تر",
  "Short, practical resources based on recurring community needs, tested security practice and accountable human review.": "منابع کوتاه و کاربردی بر پایهٔ نیازهای تکرارشوندهٔ جامعه، روش‌های امنیتی آزموده‌شده و بازبینی انسانی مسئولانه.",
  "Living, reviewed guidance": "راهنمای به‌روز و بازبینی‌شده",
  "Public pages show the latest update date. Platform Admin manages drafts, languages, ordering and publication; sensitive changes require review before they become public.": "صفحات عمومی تاریخ آخرین به‌روزرسانی را نمایش می‌دهند. مدیر پلتفرم پیش‌نویس‌ها، زبان‌ها، ترتیب و انتشار را مدیریت می‌کند؛ تغییرات حساس پیش از عمومی‌شدن بازبینی می‌شوند.",
  "Protect your accounts": "از حساب‌هایتان محافظت کنید",
  "Build phishing-resistant sign-in and a recovery plan before an attacker or lost device tests it.": "پیش از حمله یا گم‌شدن دستگاه، ورود مقاوم در برابر فیشینگ و برنامهٔ بازیابی را آماده کنید.",
  "Last updated": "آخرین به‌روزرسانی",
  "Open guide →": "باز کردن راهنما ←",
  "Recognize phishing": "فیشینگ را بشناسید",
  "Inspect suspicious messages and verify requests without following the attacker’s path.": "پیام‌های مشکوک را بررسی و درخواست‌ها را تأیید کنید، بدون آن‌که مسیر پیشنهادی مهاجم را دنبال کنید.",
  "Prepare for device confiscation": "برای ضبط دستگاه آماده شوید",
  "Reduce what a lost, seized or searched device can expose before travel, protests or other elevated-risk activity.": "پیش از سفر، اعتراضات یا فعالیت پرخطر، اطلاعاتی را که دستگاه گم‌شده، ضبط‌شده یا بازرسی‌شده می‌تواند آشکار کند کاهش دهید.",
  "Respond to doxxing": "به افشای اطلاعات شخصی واکنش نشان دهید",
  "Protect physical safety, preserve useful evidence and reduce exposure without amplifying the harmful post.": "از امنیت جسمی محافظت کنید، شواهد مفید را نگه دارید و بدون بازنشر محتوای آسیب‌زا، میزان مواجهه را کاهش دهید.",
  "Build an organization policy": "سیاست امنیتی سازمان تدوین کنید",
  "Turn digital security from individual heroics into owned, testable and supportable organizational practice.": "امنیت دیجیتال را به روشی سازمانی با مسئول مشخص، قابل آزمون و قابل پشتیبانی تبدیل کنید.",
  "Start a secure support request": "درخواست پشتیبانی امن را آغاز کنید",
  "Give a responder enough context to help while limiting unnecessary exposure at first contact.": "در تماس اول، اطلاعات کافی برای کمک ارائه دهید و از افشای غیرضروری جلوگیری کنید.",
  "NEED HELP WITH AN ACTIVE INCIDENT?": "برای رخداد در حال وقوع کمک می‌خواهید؟",
  "Contact the 24/7 Helpdesk": "تماس با پشتیبانی شبانه‌روزی",
  "Privacy-first support, forensic collection and explainable community risk intelligence.": "پشتیبانی با اولویت حریم خصوصی، جمع‌آوری شواهد و اطلاعات قابل توضیح دربارهٔ خطرهای جامعه.",
  "EXPLORE": "کاوش",
  "Safety guides": "راهنماهای امنیت",
  "ORGANIZATION": "سازمان",
  "About Kavoosh": "دربارهٔ کاووش",
  "GET SUPPORT": "دریافت پشتیبانی",
  "Contact the 24/7 Helpdesk →": "تماس با پشتیبانی شبانه‌روزی ←",
  "For urgent digital-safety incidents": "برای رخدادهای فوری امنیت دیجیتال",
  "Aggregated public insights · No personal data shown": "تحلیل عمومی تجمیع‌شده · دادهٔ شخصی نمایش داده نمی‌شود"
};

export const PUBLIC_PAGE_FA_CASELESS = Object.fromEntries(Object.entries(PUBLIC_PAGE_FA).map(([source, value]) => [source.toLowerCase(), value]));
